
import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography,Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WorkerNavBar from '../../Components/NavigationBar/WorkerNavBar';
import WorkerAttendanceGateKeeper from '../../Components/Worker/WorkerAttendanceGateKeeper';

function WorkerGateKeeper() {
    

  return (
    <WorkerNavBar>
      <Box sx={{ width: '100%' }}>
        <WorkerAttendanceGateKeeper></WorkerAttendanceGateKeeper>
      </Box>
    </WorkerNavBar>
  );
}

export default WorkerGateKeeper;
